<div mat-dialog-title>
  <span>{{'badges.modal.unassignment.title' | translate}}</span>
</div>
@if (loadingState | async; as state) {
  <div class="badge__ctn">
    <mat-dialog-content>
      @if (state === actionState.READY) {
        <!-- Badges list -->
        <p class="label">{{'badges.modal.unassignment.badges_list_message' | translate}}</p>
        <ul class="mb-20">
          @for (badge of badgesList; track badge; let isFirst = $first) {
            <li>
              <input type="radio" class="form-control" [id]="badge.uid" [checked]="isFirst"
                (change)="onChangeBadge(badge.uid, badge.value, badge.subscriptionUid)" name="unassign">
              <label [htmlFor]="badge.uid">{{badge.value}}</label>
            </li>
          }
        </ul>
        <div class="text-center mt-20">
          <button class="btn btn--primary" type="submit" [disabled]="noBadgeExistingError"
          (click)="onSubmit()">{{'action.submit' | translate}}</button>
          <button mat-dialog-close
          class="btn btn--outline-grey-color ml-20">{{'action.cancel' | translate}}</button>
        </div>
      }
      @if (state === actionState.SUCCESS) {
        <div class="alert alert-success font-size-normal text-center">
          {{'badges.modal.unassignment.message.success' | translate : {badge_number : bodyRequest.name} }}
        </div>
        <div class="mt-20 text-center">
          <button class="btn btn--primary"
          [mat-dialog-close]="actionState.SUCCESS">{{'action.close' | translate}}</button>
        </div>
      }
      @if (state === actionState.FAILED) {
        <div class="app-display-errors-message" [error]="error"></div>
        <div class="text-center mt-20">
          <button mat-dialog-close class="btn btn--outline-grey-color">{{'action.cancel' | translate}}</button>
        </div>
      }
      @if (state === actionState.LOADING) {
        <span class="ui-loading" [model]="{isLoading: true}"></span>
      }
    </mat-dialog-content>
  </div>
}